import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import axios from 'axios';
import PromoCarousel from '@/components/PromoCarousel';
import DealsCarousel from '@/components/DealsCarousel';
import CategoryGrid from '@/components/CategoryGrid';
import PromoCodeStrip from '@/components/PromoCodeStrip';

const API = window.location.origin + '/api';
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_quick-groceries-71/artifacts/wofxcf6m_ChatGPT%20Image%20May%2021%2C%202026%2C%2002_34_32%20PM.png';

export default function Home() {
  const [supermarkets, setSupermarkets] = useState([]);
  const [waLink, setWaLink] = useState('');
  const [promos, setPromos] = useState([]);
  const [coverImage, setCoverImage] = useState('');

  useEffect(() => {
    axios.get(`${API}/supermarkets`).then(r => setSupermarkets(r.data)).catch(() => {});
    axios.get(`${API}/whatsapp/order-link`).then(r => {
      if (r.data.configured) setWaLink(r.data.link);
    }).catch(() => {});
    axios.get(`${API}/settings`).then(r => {
      setCoverImage(r.data?.hero_cover_image_url || '');
    }).catch(() => {});
    axios.get(`${API}/promos`).then(r => setPromos(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  const openWhatsApp = () => {
    if (!waLink) return;
    const url = `${waLink}?text=${encodeURIComponent('Hi StoreRuns! I would like to place a grocery order. Here is my list:\n\n1. \n2. \n3. \n\nPlease let me know the total and delivery time.')}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div data-testid="home-page">
      {/* Navy Hero Banner with logo + cover image placeholder */}
      <div className="home-banner" data-testid="home-banner">
        <div className="banner-inner">
          <div className="banner-content">
            <img src={LOGO_URL} alt="StoreRuns Logo" className="banner-logo-img" data-testid="storeruns-logo" />
            <div className="banner-text">
              <h1 className="banner-title">
                <span className="title-store">Store</span><span className="title-runs">Runs</span>
                <span className="title-sub">Grocery Store</span>
              </h1>
              <p className="banner-app-label">Delivery App</p>
              <p className="banner-tagline">We Shop, We Deliver, You Relax</p>
            </div>
          </div>
          <div className="banner-grocery-img" data-testid="banner-cover-image">
            {coverImage ? (
              <img src={coverImage} alt="Cover" />
            ) : (
              <div className="banner-cover-placeholder">
                <span>Cover Image</span>
                <small>set via Admin Settings</small>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Promo Carousel */}
      <PromoCarousel promos={promos} onWhatsApp={openWhatsApp} />

      {/* Active promo codes strip */}
      <PromoCodeStrip />

      {/* Shop by Category quick-access */}
      <CategoryGrid />

      {/* Today's Deals */}
      <DealsCarousel />

      {/* Supermarket Selection */}
      <div className="home-section" data-testid="store-selector">
        <div className="home-section-header">
          <h2 className="section-heading" style={{ margin: 0 }}>Choose Your Supermarket</h2>
        </div>
        <p className="section-subtext">Tap a store to browse their products and place your order</p>
        <div className="store-cards">
          {supermarkets.map(store => (
            <Link
              key={store.slug}
              to={`/store/${store.slug}`}
              className="store-card"
              data-testid={`store-card-${store.slug}`}
            >
              <div className="store-card-logo" style={{ background: store.logo_url ? 'white' : store.color }}>
                {store.logo_url ? (
                  <img src={store.logo_url} alt={store.name} />
                ) : (
                  <span style={{ color: 'white', fontWeight: 700, fontSize: '1.2rem' }}>{store.name[0]}</span>
                )}
              </div>
              <div className="store-card-info">
                <h3>{store.name}</h3>
                {store.description && <p>{store.description}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* WhatsApp Order Link */}
      {waLink && (
        <div style={{ textAlign: 'center', padding: '8px 16px 36px' }}>
          <button
            onClick={openWhatsApp}
            data-testid="whatsapp-home-btn"
            className="whatsapp-home-link"
            style={{ border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}
          >
            <MessageCircle size={22} /> Order via WhatsApp
          </button>
        </div>
      )}
    </div>
  );
}
